export const GET_RESTAURANT_EPOPS = 'GET_RESTAURANT_EPOPS'
export const GET_RESTAURANT_EPOPS_SUCCESS = 'GET_RESTAURANT_EPOPS_SUCCESS'
export const SHOW_EPOPS_MODAL = 'SHOW_EPOPS_MODAL'
